import { render, staticRenderFns } from "./InsuranceList.vue?vue&type=template&id=72caace2&scoped=true&"
import script from "./InsuranceList.vue?vue&type=script&lang=ts&"
export * from "./InsuranceList.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceList.vue?vue&type=style&index=0&id=72caace2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72caace2",
  null
  
)

export default component.exports